import { render } from "./CurrencyInput.vue?vue&type=template&id=4eb343a4&scoped=true"
import script from "./CurrencyInput.vue?vue&type=script&lang=ts"
export * from "./CurrencyInput.vue?vue&type=script&lang=ts"

import "./CurrencyInput.vue?vue&type=style&index=0&id=4eb343a4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4eb343a4"

export default script